import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../auth/authApi';

const ForgotPasswordAppLayer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await requestPasswordReset({ email });
      setSubmitted(true);
    } catch (err) {
      setError('Failed to send reset link');
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <section
        className="auth forgot-password-page d-flex justify-content-center align-items-center p-3"
        style={{ flex: 1 }}
      >
        <div className="w-100 max-w-500-px text-center">
          {!submitted ? (
            <>
              <div className="text-center p-16 d-flex flex-column align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                  style={{ width: '90px', height: '90px' }}
                >
                  <Icon icon='mage:key' style={{ fontSize: '54px' }} />
                </div>
              </div>
              <h4 className="mb-24">Need a New Password?</h4>
              <p className="mb-32 text-secondary-light text-lg">
                Please enter the email address and we'll send you a link to reset your password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="icon-field text-start">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:email" />
                  </span>
                  <input
                    type="email"
                    className="h-56-px bg-neutral-50 radius-12"
                    style={{     
                      border: "1px solid var(--input-form-light)",
                      color: "var(--text-primary-light) !important",
                      padding: "0.5625rem 1.25rem",
                      paddingInlineStart: "2.5rem",
                      width: "100%",
                      display: "block",
                      lineHeight: "1.5",
                      backgroundClip: "padding-box",
                      transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
                    }}
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {error && <div className="text-danger mt-2">{error}</div>}

                <button
                  type="submit"
                  className="btn btn-primary btn px-12 py-12 w-50 radius-12 mt-32"
                >
                  Get Password
                </button>
                <div className="text-center mt-24">
                  <a href="samurai-app://sign-in" className="text-primary-600 fw-bold">
                    Back to Sign In
                  </a>
                </div>

                <div className="mt-120 text-center text-sm">
                  {/*<p className="mb-0">
                    Don't have an account?{' '}
                    <Link to="/sign-up" className="text-primary-600 fw-semibold">
                      Sign Up
                    </Link>
                  </p>*/}
                </div>
              </form>
            </>
          ) : (
            <div className="text-center">
              <div className="text-center p-16 d-flex flex-column align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                  style={{ width: '90px', height: '90px' }}
                >
                  <Icon icon='mdi:mail' style={{ fontSize: '54px' }} />
                </div>
              </div>
              <h4 className="mb-12">Check your inbox</h4>
              <p className="text-secondary-light mb-32 text-lg">
                We have sent an email containing instructions on how to change your password to the email address you supplied.
              </p>

              <div className="mt-120 text-center">
                <p className="mb-0">
                  <a href="samurai-app://sign-in" className="text-primary-600 fw-semibold">
                    Sign in
                  </a>
                </p>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ForgotPasswordAppLayer;

